import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

// Import Swiper styles if not already globally imported,
// though they should be since we use Swiper in other modules.
import "swiper/css/pagination";

export default function initImageCarousel() {
  const carousels = document.querySelectorAll(".image_caro");

  if (!carousels.length) return;

  console.log("Image Carousel found, initializing...");

  carousels.forEach((carousel) => {
    new Swiper(carousel, {
      modules: [Pagination, Autoplay],
      loop: true,
      slidesPerView: 2,
      spaceBetween: 24,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 5,
        },
      },
    });
  });
}
